// extracted by mini-css-extract-plugin
module.exports = {"Rating":"RateCompanyModal_Rating__2Acj4"};